import React from "react";

import FixedMenu from "../fixedMenu/fixedMenu.container";
import FixedInfo from "../fixedInfo/fixedInfo.container";
import useMediaQuery from "../../hooks/useMediaQuery";

const Fixed = () => {
  let size = useMediaQuery();

  return (
    <div className="position-relative h-100 d-flex justify-content-between">
      {!["xm"].includes(size) && <FixedMenu />}
      {!["xm", "sm", "md"].includes(size) && <FixedInfo />}
    </div>
  );
};

export default Fixed;
